module.exports = "/next-static/_next/static/images/block_image_live_video-be898a2f6f6dc76b52076e43ffe9be32.webp";